import DesktopMain from "./desktop/DesktopMain";
import MobileMain from "./mobile/MobileMain";
import MediaQuery from "react-responsive";
import React from "react";

function balanceContainer() {
    return (
        <MediaQuery maxWidth="599px">
            {(isMobile) => {
                return isMobile ? <MobileMain /> : <DesktopMain />;
            }}
        </MediaQuery>
    );
}

export default balanceContainer;
